/**
 * Puntos de recogida API
 * Puntos de recogida API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoDocumentoDTO } from './tipoDocumentoDTO';


export interface DocumentoDTO { 
    id?: number;
    nombre?: string;
    descripcion?: string;
    contenedor?: string;
    url?: string;
    idEntidad?: number;
    tipoEntidad?: DocumentoDTO.TipoEntidadEnum;
    tipoDocumento?: TipoDocumentoDTO;
    fechaCreacion?: string;
    fechaModificacion?: string;
    usuarioModificacion?: string;
}
export namespace DocumentoDTO {
    export type TipoEntidadEnum = 'ADMINISTRACION' | 'ADHERIDO' | 'POSEEDOR' | 'GESTOR' | 'GESTOR_POSEEDOR' | 'DISTRIBUIDOR' | 'PUNTO_RECOGIDA' | 'GESTOR_PUNTO_RECOGIDA' | 'REACONDICIONADOR' | 'APORTACION_DI_POSEEDOR' | 'APORTACION_DI_ADHERIDO' | 'APORTACION_DI_GESTOR' | 'SOLICITUDES_PR' | 'COMUNICACION' | 'ACUERDOS_GESTORES';
    export const TipoEntidadEnum = {
        Administracion: 'ADMINISTRACION' as TipoEntidadEnum,
        Adherido: 'ADHERIDO' as TipoEntidadEnum,
        Poseedor: 'POSEEDOR' as TipoEntidadEnum,
        Gestor: 'GESTOR' as TipoEntidadEnum,
        GestorPoseedor: 'GESTOR_POSEEDOR' as TipoEntidadEnum,
        Distribuidor: 'DISTRIBUIDOR' as TipoEntidadEnum,
        PuntoRecogida: 'PUNTO_RECOGIDA' as TipoEntidadEnum,
        GestorPuntoRecogida: 'GESTOR_PUNTO_RECOGIDA' as TipoEntidadEnum,
        Reacondicionador: 'REACONDICIONADOR' as TipoEntidadEnum,
        AportacionDiPoseedor: 'APORTACION_DI_POSEEDOR' as TipoEntidadEnum,
        AportacionDiAdherido: 'APORTACION_DI_ADHERIDO' as TipoEntidadEnum,
        AportacionDiGestor: 'APORTACION_DI_GESTOR' as TipoEntidadEnum,
        SolicitudesPr: 'SOLICITUDES_PR' as TipoEntidadEnum,
        Comunicacion: 'COMUNICACION' as TipoEntidadEnum,
        AcuerdosGestores: 'ACUERDOS_GESTORES' as TipoEntidadEnum
    };
}


